import React from 'react';
import PropTypes from 'prop-types';
import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';

import 'inventory-listing/components/ListingFilters/Components/ListingFiltersBodyStyle/BodyStyle.scss';

const Bodystyle = ({ bodystyle, handleChange }) => {
    const bodyStyleClasses = ['listing-used-bodystyle'];
    bodyStyleClasses.push(bodystyle.class);

    if (bodystyle.isSelected) {
        bodyStyleClasses.push('selected is-price');
    }
    const label = bodystyle.count > 0 ? `${bodystyle.label} (${bodystyle.count})` : bodystyle.label;
    return (
        <div
            role="button"
            tabIndex={0}
            className={bodyStyleClasses.join(' ')}
            onClick={() => handleChange(bodystyle.group)}
        >
            {label}
        </div>
    );
};

Bodystyle.propTypes = {
    bodystyle: PropTypes.instanceOf(MetaDataModel),
    handleChange: PropTypes.func.isRequired,
};

Bodystyle.displayName = 'Bodystyle';

export default Bodystyle;
